// extracted by mini-css-extract-plugin
module.exports = {"is-hidden":"countdown_is-hidden__W26Ww"};